import React from 'react';
import type { ChatMessage } from '../../../../channels/chat/components/sharedChatService';
import LiveDiscoveryDocument from './LiveDiscoveryDocument';

interface DiscoveryDocumentsShellProps {
    projectName: string;
    projectId?: number | string | null;
    chatMessages: ChatMessage[];
}

/**
 * Centered card wrapping {@link LiveDiscoveryDocument} — shared by discovery chat and Requirements → Documents.
 */
const DiscoveryDocumentsShell: React.FC<DiscoveryDocumentsShellProps> = ({
    projectName,
    projectId,
    chatMessages,
}) => (
    <div className="flex h-full w-full min-h-0 flex-col overflow-y-auto overflow-x-hidden bg-transparent">
        <div className="mx-auto flex w-full max-w-5xl flex-1 flex-col min-h-0 px-4 py-4 sm:px-6 sm:py-6 lg:px-8 lg:py-8">
            <div className="flex min-h-[min(720px,85vh)] flex-1 flex-col overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-lg shadow-slate-900/[0.07]">
                <LiveDiscoveryDocument
                    projectName={projectName}
                    projectId={projectId ?? null}
                    chatMessages={chatMessages}
                />
            </div>
        </div>
    </div>
);

export default DiscoveryDocumentsShell;
